(function () {
  window.initFragranceFinderResultLp = function () {
    var $ = window.jQuery;
    if (!$ || typeof $.fn.on !== 'function') {
      console.error('[LP] jQuery is required for initFragranceFinderResultLp');
      return;
    }
    function bindLoad(fn) {
      var run = function () {
        try { fn(); } catch (e) { console.warn('[LP] initFragranceFinderResultLp bindLoad', e); }
      };
      if (document.readyState === 'complete') run();
      else $(window).on('load', run);
    }
    function safeTop(target) {
      try {
        var $el = target && target.jquery ? target : $(target);
        if (!$el || !$el.length) return 0;
        var o = $el.offset();
        return o ? o.top : 0;
      } catch (e) {
        return 0;
      }
    }

    /* --- block 1 --- */
    (function () {
      try {
        $('.tk-item__list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          infinite: false
        });

      } catch (e) { console.warn('[LP] initFragranceFinderResultLp block 1', e); }
    })();

    /* --- block 2 --- */
    (function () {
      try {
        $('.fragrance-pairing__list').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          swipe: true,
          infinite: false,
          dots: false,
          adaptiveHeight: true,

          responsive: [{
            breakpoint: 960,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

      } catch (e) { console.warn('[LP] initFragranceFinderResultLp block 2', e); }
    })();

    /* --- block 3 --- */
    (function () {
      try {

        var sizes = ['l', 's'];

  // =========================
  // Slick初期化
  // =========================
  $('.lineup__list').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    swipe: true,
    infinite: false,
    dots: false,
    adaptiveHeight: true,

    responsive: [{
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });


  // =========================
  // 容量変更
  // =========================
  function changeSize(size) {

    var index = sizes.indexOf(size);
    var $slider = $('.lineup__list');

    $slider.slick('slickGoTo', index);

    $('.size-filter li').removeClass('active');

    $('.size-filter li[data-size="' + size + '"]')
      .addClass('active');
  }


  // =========================
  // Slickスライド変更時
  // 容量ボタンも連動
  // =========================
  $('.lineup__list').on('afterChange', function (event, slick, currentSlide) {

    // SPのみ
    if ($(window).width() > 960) return;

    var size = sizes[currentSlide];

    $('.size-filter li').removeClass('active');

    $('.size-filter li[data-size="' + size + '"]')
      .addClass('active');
  });


  // =========================
  // 初期表示
  // =========================
  changeSize('l');


  // =========================
  // 容量ボタン（SPのみ）
  // =========================
  $('.size-filter li').on('click', function () {

    if ($(window).width() > 960) return;

    var size = $(this).data('size');

    changeSize(size);
  });


  // =========================
  // Next（SPのみ）
  // =========================
  $('.lineup-next').on('click', function () {

    if ($(window).width() > 960) return;

    var current = $('.size-filter li.active').data('size');

    var index = sizes.indexOf(current);

    var next = sizes[(index + 1) % sizes.length];

    changeSize(next);
  });


  // =========================
  // Prev（SPのみ）
  // =========================
  $('.lineup-prev').on('click', function () {

    if ($(window).width() > 960) return;

    var current = $('.size-filter li.active').data('size');

    var index = sizes.indexOf(current);

    var prev = sizes[(index - 1 + sizes.length) % sizes.length];

    changeSize(prev);
  });
        $(window).on('load scroll', function () {

          var pl = $(this).scrollTop();
          if (pl == 0) {
            $(".pagetop").css("display", "none");
          } else {
            $(".pagetop").css("display", "block");
          }

          var menu_pos = $(".cbg").offset().top - 1;

          if (pl >= menu_pos) {
            $('.open-menu-out').addClass("view");
          } else {
            $('.open-menu-out').removeClass("view");
          }
        });

        $(window).on('load scroll', function () {
          var pl = $(this).scrollTop();
          if (pl == 0) {
            $(".pagetop").css("display", "none");
          } else {
            $(".pagetop").css("display", "block");
          }
        });

        bindLoad( function () {
          if (location.hash !== "") {
            var targetOffset = safeTop($(location.hash));
            $(window).delay(1000).scrollTop(targetOffset);
          }
        });
      } catch (e) { console.warn('[LP] initFragranceFinderResultLp block 3', e); }
    })();



    /* inview: 動的読込後も表示する */
    (function () {
      try {
        var $els = $('.inview');
        if (!$els.length) return;
        $els.each(function () {
          var $el = $(this);
          if ($el.data('lpInviewBound')) return;
          $el.data('lpInviewBound', 1);
          $el.one('inview', function (event, isInView) {
            if (isInView) $(this).stop().animate({ opacity: 1 }, 500);
          });
        });
        $(window).trigger('scroll');
      } catch (e) {}
    })();
  };

  window.destroyMintySparkYuzuLp = function () {
    var $ = window.jQuery;
    if (!$) return;
    try {
      $('.slick-initialized').each(function () { $(this).slick('unslick'); });
    } catch (e) {}
    try {
      document.querySelectorAll('.swiper').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    } catch (e) {}
    $('.open-modal').off('click');
    $('.pagetop a').off('click');
  };
})();